import axios from 'axios';
import appStore from '@/store/app';
import { Partner, Result } from '@/models';
import { Api, ApiResult, ResultOf } from '@/types';

const fetchPartnersAsync: (keyword: string) => Promise<ResultOf<Partner>> = async (keyword) => {

   appStore.loading({ isLoading: true });

   return await axios.get<ResultOf<Partner>>(Api.BaseUrl + `partners/search/${keyword}`)
      .then((response) => {
         return response.data || { total: 0, payload: [], succeeded: false } as ResultOf<Partner>;
      })
      .catch((reason) => {
         if (reason && reason.response) {
            appStore.errors({ status: reason.response.status, result: reason.response.data as ApiResult, ignoreNotFound: true });
         }
         return { total: 0, payload: [], succeeded: false } as ResultOf<Partner>;
      })
      .finally(() => {
         appStore.loading({ isLoading: false });
      });
};

const syncProductsHistoryAsync: (partnerCode: number) => Promise<Result> = async (partnerCode) => {

   appStore.loading({ isLoading: true });

   return await axios.post<Result>(Api.BaseUrl + `partners/syncProductsHistory/${partnerCode}`)
      .then((response) => {
         if (response.status === 200) {
            appStore.success({ message: 'Storico Prodotti sincronizzato con successo.' });
         }
         return response.data;
      })
      .catch((reason) => {
         if (reason) {
            if (reason.code === 'ECONNABORTED') {
               appStore.errors({ status: 9999, result: { status: 9999, detail: 'La richiesta è andata in timeout. Rieseguire l\'operazione.' } as ApiResult
                     , ignoreNotFound: true });
            }
            else if (reason.response) {
               appStore.errors({ status: reason.response.status, result: reason.response.data as ApiResult, ignoreNotFound: true });
            }
         }
         return { success: false  } as Result;
      })
      .finally(() => {
         appStore.loading({ isLoading: false });
      });
};

const syncOrdersHistoryAsync: (partnerCode: number) => Promise<Result> = async (partnerCode) => {

   appStore.loading({ isLoading: true });

   return await axios.post<Result>(Api.BaseUrl + `partners/syncOrdersHistory/${partnerCode}`)
      .then((response) => {
         if (response.status === 200) {
            appStore.success({ message: 'Storico Ordini sincronizzato con successo.' });
         }
         return response.data;
      })
      .catch((reason) => {
         if (reason) {
            if (reason.code === 'ECONNABORTED') {
               appStore.errors({ status: 9999, result: { status: 9999, detail: 'La richiesta è andata in timeout. Rieseguire l\'operazione.' } as ApiResult
                     , ignoreNotFound: true });
            }
            else if (reason.response) {
               appStore.errors({ status: reason.response.status, result: reason.response.data as ApiResult, ignoreNotFound: true });
            }
         }
         return { success: false  } as Result;
      })
      .finally(() => {
         appStore.loading({ isLoading: false });
      });
};

const partnersService = {
   fetchPartnersAsync,
   syncProductsHistoryAsync,
   syncOrdersHistoryAsync,
};

export default partnersService;
